import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, Container, Divider } from '@mui/material';
import { Form, useFormApi } from 'informed';
import forEach from 'lodash.foreach';

export default function FormContainer({ maxWidth = "md", children, title, subheader, onSubmit, initialValues, validationSchema, serverError }) {

  return (
    <Container maxWidth={maxWidth}>
      <Card>
        <CardHeader
          title={title}
          subheader={subheader}
        />
        <Divider />
        <CardContent>
          <Form onSubmit={onSubmit} initialValues={initialValues} yupSchema={validationSchema}>
            <Fields serverError={serverError} children={children} />
          </Form>
        </CardContent>
      </Card>
    </Container>
  );
}

const Fields = ({ serverError, children }) => {
  const formApi = useFormApi();

  useEffect(() => {
    if (serverError?.response.status === 422 && serverError?.response.data.errors) {
      forEach(serverError?.response.data.errors, (value, key) => {
        formApi.setError(key, value);
      });
    }
  }, [formApi, serverError]);

  return children;
};
